import { ReactComponent as BookedSeat } from '../images/seating/siege-booked.svg';
import { ReactComponent as AvailableSeat } from '../images/seating/siege-available.svg';
import { ReactComponent as BookingInProgressSeat } from '../images/seating/siege-booking-in-progress.svg';
import { ReactComponent as UnavailableSeat } from '../images/seating/siege-unavailable.svg';
import { ReactComponent as ReservedSeat } from '../images/seating/siege-reserved.svg';
import { ReactComponent as LockedForSocialDistancing } from '../images/seating/siege-empty.svg';
import { ReactComponent as SelectedSeat } from '../images/seating/siege-selected.svg';

const reservedStates = {
    booking_in_progress_for_partner: ReservedSeat,
    booked_by_reservation: ReservedSeat,
    partially_available: ReservedSeat,
    partially_booked: ReservedSeat,
    partially_booking_in_progress: ReservedSeat,
};

export default {
    booked: BookedSeat,
    available: AvailableSeat,
    booking_in_progress: BookingInProgressSeat,
    unavailable: UnavailableSeat,
    locked_for_social_distancing: LockedForSocialDistancing,
    selected: SelectedSeat,
    ...reservedStates,
};